import { toast } from 'react-toastify'
export const toastActive = e => {
  toast(e, {
    position: 'top-center',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    type: 'success',
  })
}
